export default __webpack_public_path__ + "static/media/et-ha.769feb24.svg";